import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ScanBinder } from '@components/partials/scan/scan-binder/scan-binder';
import { UiModule } from '@components/ui/ui-module';
import { UserBinder } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';
import { map, switchMap } from 'rxjs';

@Component({
  selector: 'lgb-open-binder',
  imports: [
    UiModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ScanBinder
  ],
  templateUrl: './open-binder.html',
  styleUrl: './open-binder.css',
})
export class OpenBinder {
  readonly binderS=inject(BinderService);
  readonly router=inject(Router);
  readonly route=inject(ActivatedRoute);

  readonly loading=signal(false);
  readonly error=signal<string>(null);
  readonly msg=signal<string>(null);
  readonly opened=signal(false);
  readonly code=signal<string>(null);
  readonly binder=signal<UserBinder>(null);
  readonly enableScan=signal<boolean>(false);

  constructor(){
    this.route.paramMap
      .pipe(
        map(params => {
          if(params.get('id')){
            this.loading.set(true);
            return params.get('id');
          }
          else
            return null;
        })
      )
      .subscribe(code => {
        if(code){
          this.loading.set(false);
          this.scan(code);
        }
      });
  }

  private getNext(){
    return {
        next: (uBinder: UserBinder) => {
          this.msg.set('Félicitations, ton binder est prêt à être utilisé');
          this.binder.set(uBinder);
          this.opened.set(true);
          this.loading.set(false);
        },
        error: (e: any) => {
          this.error.set(e);
          this.loading.set(false);
        }
      };
  }

  openCustomBinder(){
    this.loading.set(true);
    this.binderS.openCustomBinder().subscribe(this.getNext());
  }

  openBinder(){
    this.loading.set(true);
    this.binderS.openBinder(this.code()).subscribe(this.getNext());
  }

  reset(){
    this.opened.set(false);
    this.msg.set(null);
  }

  scan(code: string){
    this.enableScan.set(false);
    code=code.replace('https://legend-binder.com/open/', '');
    this.loading.set(true);
    this.binderS.openBinder(code).subscribe(this.getNext());
  }
}
